export const environment = {
  production: true,
  NEGOTIOR: 'https://cobranca.pravaler.com.br/negotior/',
  INTEGRATION: 'https://cobranca.pravaler.com.br/integration/',
  AUTH: 'https://gtw-keymaker.pravaler.com.br/v1/',
  KRAKEND: 'https://cobranca.pravaler.com.br/',
  ATENDIMENTO_API: 'https://atendimento-gtw.pravaler.com.br/'
};
